import * as PIXI from 'pixi.js';
import {Main} from '../Main';
import {Const} from '../Const';
import {TweenMax,TimelineMax,Sine, Bounce, Power1,Power2, Elastic, Power3} from "gsap";
//プラグインの読み込み
import 'pixi-picture';
import {TimelinePlus} from './TimelinePlus';

export class Names extends PIXI.Container {

	container:PIXI.Graphics
	names:PIXI.Sprite[] = [];
	namePos:PIXI.Point[] = [];
	nameEndPos:PIXI.Point[] = [];
	nameEndR:number[] = [];
	constructor() {
		super();
		this.container = new PIXI.Graphics();
		this.addChild(this.container);

		Main.instance.stage.addChild(this);
		this.alpha = 0;
		for (let i = 0; i < 14; i++) {
			this.namePos[i] = new PIXI.Point();
			this.nameEndPos[i] = new PIXI.Point();
			this.names[i] = new PIXI.Sprite(PIXI.Texture.fromFrame('name_'+i+'.png'));
			this.names[i].texture.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR;
			this.names[i].pivot.x=this.names[i].width*0.5;
			this.names[i].pivot.y=this.names[i].height*0.5;
			this.addChild(this.names[i]);
		}

		this.namePos[0].x=3;
		this.namePos[0].y=623;
		this.namePos[1].x=361;
		this.namePos[1].y=706;
		this.namePos[2].x=537;
		this.namePos[2].y=705;
		this.namePos[3].x=690;
		this.namePos[3].y=706;
		this.namePos[4].x=858;
		this.namePos[4].y=673;
		this.namePos[5].x=1002;
		this.namePos[5].y=706;
		this.namePos[6].x=1169;
		this.namePos[6].y=612;
		this.namePos[7].x=1381;
		this.namePos[7].y=706;
		this.namePos[8].x=1663;
		this.namePos[8].y=622;
		this.namePos[9].x=1864;
		this.namePos[9].y=706;
		this.namePos[10].x=2031;
		this.namePos[10].y=612;
		this.namePos[11].x=2242;
		this.namePos[11].y=706;
		this.namePos[12].x=2415;
		this.namePos[12].y=705;
		this.namePos[13].x=2637;
		this.namePos[13].y=705;

		for (let i = 0; i < 14; i++) {
			this.nameEndPos[i].x = this.names[i].x= this.namePos[i].x = this.namePos[i].x - (2800/2 - this.names[i].pivot.x);
			this.nameEndPos[i].y = this.names[i].y= this.namePos[i].y = this.namePos[i].y - (871/2 - this.names[i].pivot.y) + 80;
		}

		this.nameEndPos[0].x-=400; //M
		this.nameEndPos[1].x-=300; //a
		this.nameEndPos[2].x-=200; //s
		this.nameEndPos[3].x-=100; //a
		this.nameEndPos[4].x-=50; //t
		this.nameEndPos[5].x-=0;	//a
		this.nameEndPos[6].x-=0;	//k
		this.nameEndPos[7].x-=0;	//a

		this.nameEndPos[8].x+=0;	//s
		this.nameEndPos[9].x+=0; //a
		this.nameEndPos[10].x+=150; //k
		this.nameEndPos[11].x+=150; //a
		this.nameEndPos[12].x+=300; //n
		this.nameEndPos[13].x+=500; //o
	

		this.nameEndPos[0].y=20; //M
		this.nameEndPos[1].y=0; //a
		this.nameEndPos[2].y=30; //s
		this.nameEndPos[3].y=0; //a
		this.nameEndPos[4].y=60; //t
		this.nameEndPos[5].y=0;	//a
		this.nameEndPos[6].y=130;	//k
		this.nameEndPos[7].y=160;	//a

		this.nameEndPos[8].y=80;	//s
		this.nameEndPos[9].y=0; //a
		this.nameEndPos[10].y=80; //k
		this.nameEndPos[11].y=20; //a
		this.nameEndPos[12].y=50; //n
		this.nameEndPos[13].y=0; //o

		this.nameEndR[0]=-0.5; //M
		this.nameEndR[1]=0.8; //a
		this.nameEndR[2]=0.3; //s
		this.nameEndR[3]=1; //a
		this.nameEndR[4]=0.5; //t
		this.nameEndR[5]=0.3;	//a
		this.nameEndR[6]=-0.4;	//k
		this.nameEndR[7]=-0.8;	//a

		this.nameEndR[8]=0.5;	//s
		this.nameEndR[9]=-0.7; //a
		this.nameEndR[10]=0.4; //k
		this.nameEndR[11]=-0.4; //a
		this.nameEndR[12]=-0.5; //n
		this.nameEndR[13]=1; //o

	}

	start(type:string) {
		var w:number= document.documentElement.clientWidth;
		var h:number= window.innerHeight;
		if(w > h || (Main.instance.device === 'pc' && w > 768)) {
			h = (h<1000)?h:1000;
		}
		var ex = ((h-this.y)/this.scale.y);

		this.alpha = 1;
		var ex = ((h-this.y)/this.scale.y);

		

		for (let i = 0; i < 14; i++) {

			var ty = (this.namePos[i].y*1.3)-this.random(1000,2000);
			var nx = (ex-this.nameEndPos[i].y*4);
			var range = nx - ty;
			var rotation = 0;
			const t2 = new TimelineMax();
			t2.add(TweenMax.to(this.names[i], 0.5, {
					y:nx,
					ease: Power2.easeIn
				})
			)
			for (let n = 0; n < 5; n++) {
				//rotation+=this.random(-2*Math.pow(0.6,n+1),2*Math.pow(0.6,n+1));
				rotation += this.nameEndR[i]*Math.pow(0.6,n+1);

				t2.add(TweenMax.to(this.names[i], 0.5*Math.pow(0.6,n+1), {
					y:nx-range*Math.pow(0.6,n+1),
					rotation:rotation,
					ease: Power2.easeOut
				}))
				t2.add(TweenMax.to(this.names[i], 0.5*Math.pow(0.6,n+1), {
					y:nx,
					ease: Power2.easeIn
				}))
			}

			TimelinePlus.parallel(
				TweenMax.fromTo(this.names[i], 0.5,
					{
						x:this.namePos[i].x*2,
						y:this.namePos[i].y*2-2000,
						pixi:{alpha:0,scale:3},
					},
					{
						x:this.namePos[i].x,
						y:this.namePos[i].y,
						pixi:{alpha:1,scale:1},
						ease:Power1.easeIn,
						delay:0.05*i
					}
				),
				TimelinePlus.serial(
					TweenMax.to(this.names[i], 0.5, {
						x:this.namePos[i].x*0.2,
						y:this.namePos[i].y*0.2+500+this.random(-200,200),
						alpha: 0.3,
						pixi:{scale:0.2},
						ease: Power1.easeOut,
						delay:((i<8)?1.0:1.4)-0.1*i
						}
					),
					TweenMax.to(this.names[i], 0.75, {
						x:this.nameEndPos[i].x*0.9,
						y:this.nameEndPos[i].y*1.3-this.random(2000,3000),
						alpha: 0.3,
						pixi:{scale:3},
						ease: Power1.easeIn,
						}
					),
					TimelinePlus.parallel(
						//ここからバウンド
						t2
					)
				).delay(1)
				,

			);
		}
	}

	logoin() {
		var w:number= document.documentElement.clientWidth;
		var h:number= window.innerHeight;
		if(w > h || (Main.instance.device === 'pc' && w > 768)) {
			h = (h<1000)?h:1000;
		}
		var ex = ((h-this.y)/this.scale.y);
		this.alpha = 1;
		
		for (let i = 0; i < 14; i++) {
			TweenMax.to(this.names[i], 1, {
				alpha: 0,
			})
		}
		
	}

	skip() {
		var w:number= document.documentElement.clientWidth;
		var h:number= window.innerHeight;
		if(w > h || (Main.instance.device === 'pc' && w > 768)) {
			h = (h<1000)?h:1000;
		}
		var ex = ((h-this.y)/this.scale.y);
		for (let i = 0; i < 14; i++) {
			var nx = (ex-this.nameEndPos[i].y*4);
			this.names[i].x=this.nameEndPos[i].x*0.9;
			this.names[i].y=nx;
			this.names[i].alpha=0;
			this.names[i].width = this.names[i].width*3;
			this.names[i].height = this.names[i].height*3;
			this.names[i].rotation = this.nameEndR[i];
			//this.random(-2,2);
		}
	}


	resize(h) {
		var ex = ((h-this.y)/this.scale.y);
		
		for (let i = 0; i < 14; i++) {
			var nx = (ex-this.nameEndPos[i].y*4);
			this.names[i].y=nx;
		}
	}

	random(min, max){
		return (Math.random() * (max - min)) + min;
	}



}